import { render } from "./SectionPriceSelect.vue?vue&type=template&id=8fd692d2&scoped=true"
import script from "./SectionPriceSelect.vue?vue&type=script&lang=js"
export * from "./SectionPriceSelect.vue?vue&type=script&lang=js"

import "./SectionPriceSelect.vue?vue&type=style&index=0&id=8fd692d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd692d2"]])

export default __exports__